import { render, staticRenderFns } from "./RulerFab.vue?vue&type=template&id=3705576e&lang=pug&"
import script from "./RulerFab.vue?vue&type=script&lang=js&"
export * from "./RulerFab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "RulerFab.vue"
export default component.exports